import { watchers as loginWatchers } from 'auth/login';
import { watchers as regWatchers } from 'auth/registration';
import { watchers as resetWatchers } from 'auth/resetPassword';
import { watchers as resendWatchers } from 'auth/resendEmailConfirmation';
import { watchers as tfaWatchers } from 'auth/twoStepAuth';

export default [...loginWatchers, ...regWatchers, ...resetWatchers, ...resendWatchers, ...tfaWatchers];
